import React from 'react';

// import components
import ImageGallery, { Card } from 'components/partials/image-gallery';

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";

const ImageGalleryBuilder: React.FC<{ imageGalleryData?: Queries.ImageGalleryBlockFragment }> = ({ imageGalleryData }) => {

    if (!imageGalleryData) return null;

    const cards: Card[] = imageGalleryData.images?.map((image): Card | undefined => {
        if (!image) return undefined;

        let cardImage = undefined;

        if (image.image?.gatsbyImageData) {
            cardImage = isGatsbyImageData(image.image.gatsbyImageData) ? image.image.gatsbyImageData : undefined;
        }

        return {
            gatsbyImageData: cardImage,
            caption: image.image?.title || '',
            alt: image.image?.alt || ''
        };

    }).filter((card): card is Card => card !== undefined) as Card[] || [];

    return (
        <ImageGallery
            cards={cards}
        />
    );
};

export default ImageGalleryBuilder;